import { MockFactory } from '@tino-frontend/mocks'
import { MerchantStatus, type GetMerchantsResponseData } from '@types'

export const listMerchantsMock = new MockFactory<GetMerchantsResponseData>({
  merchants: [
    {
      id: '04b721b6-c328-4705-b24c-04d54db91571',
      document_number: '57182365000100',
      name: 'Mock Company 1',
      status: MerchantStatus.PendingIdentification,
      created_at: '2024-11-07T14:47:49.596899Z' as any,
    },
    {
      id: '04b721b6-c328-4705-b24c-04d54db91572',
      document_number: '57182365000101',
      name: 'Mock Company 2',
      status: MerchantStatus.WaitingLimitAnalisys,
      created_at: '2024-11-07T14:47:49.596899Z' as any,
    },
    {
      id: '04b721b6-c328-4705-b24c-04d54db91573',
      document_number: '57182365000102',
      name: 'Mock Company 3',
      status: MerchantStatus.BlockedLimit,
      created_at: '2024-11-07T14:47:49.596899Z' as any,
    },
    {
      id: '04b721b6-c328-4705-b24c-04d54db91574',
      document_number: '57182365000103',
      name: 'Mock Company 4',
      status: MerchantStatus.Allowed,
      created_at: '2024-11-07T14:47:49.596899Z' as any,
    },
    {
      id: '04b721b6-c328-4705-b24c-04d54db91577',
      document_number: '57182365000106',
      name: 'Mock Company 7',
      status: MerchantStatus.RequestedTerms,
      created_at: '2024-11-07T14:47:49.596899Z' as any,
    },
  ],
})
